<template>
    <v-container fluid ma-0 pa-0 fill-height>
        <v-img :src="require('../assets/background.jpg')" height="100%" align="center" justify="center">
            <v-container class="text-center" fill-height>
                <v-row >
                <v-col cols="12">
                    <h1>Gitlab Redmine Webhook</h1>
                    <GoogleLogin align="center" justify="center" :params="params" :renderParams="renderParams" :onSuccess="onSuccess" :onFailure="onFailure"></GoogleLogin>
                </v-col>
                </v-row>
            </v-container>
        </v-img>
    </v-container>
</template>

<script>
import GoogleLogin from 'vue-google-login';
export default {
    components: {
        GoogleLogin,
    },
    data () {
        return {
            params: {
                client_id: '112985607289-obhtidl2a2dfnh7eek47i1583e75c748.apps.googleusercontent.com'
            },
            renderParams: {
                width: 250,
                height: 50,
                longtitle: true
            }
        }
    },
    methods: {
        onSuccess (googleUser) {
            const authResponse = googleUser.getAuthResponse(true)
            this.$store.dispatch('authentication/auth', authResponse.id_token)
        },
        onFailure () {

        },
    },
}
</script>

<style>
</style>
